import React from "react";
import MobileMarket from "../MobileMarket/MobileMarket";
import Posts from "../Posts/Posts";
import "./PostContainer.css";
import { Divider, Tab } from "semantic-ui-react";
import { isMobile } from "react-device-detect";
import TradingPlan from "../Posts/TradingPlan";
import Learning from "../Posts/Learning";
import MarketInsight from "../Posts/MarketInsight";
import MarketKnowledge from "../Posts/MarketKnowledge";
import MarketToday from "../Posts/MarketToday";
import OnlineClass from "../Posts/OnlineClass";
import CustomTabMenu from "./CustomTabMenu";
import { useMetaData } from "../../Context/MetaDataContext";
const SmartTradingHub = () => {
  const { metaData } = useMetaData();
  const panes = [
    {
      menuItem: {
        key: "markettoday",
        icon: "desktop",
        content: `${metaData.MENU.MARKET_TODAY}`,
      },
      render: () => (
        <Tab.Pane attached={false}>
          <MarketToday />
        </Tab.Pane>
      ),
    },
    {
      menuItem: {
        key: "livesetup",
        icon: "chart line",
        content: `${metaData.MENU.LIVE_SETUP}`,
      },
      render: () => (
        <Tab.Pane attached={false}>
          <Posts />
        </Tab.Pane>
      ),
    },
    {
      menuItem: {
        key: "tradingplan",
        icon: "idea",
        content: `${metaData.MENU.TRADING_PLAN}`,
      },
      render: () => (
        <Tab.Pane attached={false}>
          <TradingPlan />
        </Tab.Pane>
      ),
    },

    {
      menuItem: {
        key: "marketknowledge",
        icon: "write",
        content: `${metaData.MENU.MARKET_KNOWLEDGE}`,
      },
      render: () => (
        <Tab.Pane attached={false}>
          <MarketKnowledge />
        </Tab.Pane>
      ),
    },
    {
      menuItem: {
        key: "marketinsight",
        icon: "coffee",
        content: `${metaData.MENU.MARKET_INSIGHT}`,
      },
      render: () => (
        <Tab.Pane attached={false}>
          <MarketInsight />
        </Tab.Pane>
      ),
    },
    {
      menuItem: {
        key: "TechnicalLearning",
        icon: "chart bar",
        content: `${metaData.MENU.TECHNICAL_LEARNING}`,
      },
      render: () => (
        <Tab.Pane attached={false}>
          <Learning />
        </Tab.Pane>
      ),
    },
    {
      menuItem: {
        key: "class",
        icon: "book",
        content: `${metaData.MENU.CLASS}`,
      },
      render: () => (
        <Tab.Pane attached={false}>
          <OnlineClass />
        </Tab.Pane>
      ),
    },
  ];
  return (
    <div className="SmartTradingHub">
      <MobileMarket />
      {!isMobile && (
        <>
          <div className="">
            <Divider horizontal>{metaData.WELCOME.NAME}</Divider>
          </div>
        </>
      )}
      <CustomTabMenu panes={panes} />
    </div>
  );
};

export default SmartTradingHub;
